import { withTranslation } from "next-i18next";
import { useRouter } from "next/compat/router";
import classNames from "classnames";
import useFeatures from "@hooks/use-features";
import { useFormatDate } from "@hooks/use-format-date";
import translateVariantSize from "@utils/translateVariantSize";
import ProductGlobalRating from "./ProductGlobalRating";

function ProductReviewCard({ review, className, t }) {
  const router = useRouter();
  const formatDate = useFormatDate();
  const { locale } = router;

  const { bra_sizes_grouped: braSizesGrouped } = useFeatures();
  const showBraSize = braSizesGrouped?.length > 0;

  return (
    <div className={classNames("product-review-offcanvas-card", className)}>
      <div
        className={classNames(
          "shared-picture-container",
          !review.shared_picture?.image_url && "no-picture",
        )}
      >
        <img
          src={review.shared_picture?.image_url}
          alt=""
          loading="lazy"
        />
      </div>

      <div className="user-review">
        <div className="user-informations">
          <p className="font-weight-bold text-capitalize">{review.user?.first_name}</p>

          <div className="mb-2">
            <p className="mb-0">
              <span className="text-gray">{t("product:size_weared")}</span>
              {review.closet_item_size
                ? translateVariantSize(
                    review.closet_item_size.type,
                    review.closet_item_size.value,
                    t,
                  )
                : "-"}
            </p>
            <p className="mb-0">
              <span className="text-gray">{t("product:user_fit_feeling.title")}</span>
              {review.fit ? t(`product:user_fit_feeling.${review.fit}`) : "-"}
            </p>
          </div>

          <div>
            <p className="mb-0">
              <span className="text-gray">{t("product:user_height")}</span>
              {review.user_height ? t("product:height_cm", { height: review.user_height }) : "-"}
            </p>

            <p className="mb-0">
              <span className="text-gray">{t("product:user_weight")}</span>
              {review.user_weight ? t("product:weight_kg", { weight: review.user_weight }) : "-"}
            </p>

            <p className="mb-0">
              <span className="text-gray">{t("product:user_morphology")}</span>
              {review.user_morphology ? t(`product:morphologies.${review.user_morphology}`) : "-"}
            </p>

            {showBraSize && (
              <p className="mb-0">
                <span className="text-gray">{t("product:user_bra_size")}</span>
                {review.user_bra_size ? t(`product:bra_sizes.${review.user_bra_size}`) : "-"}
              </p>
            )}
          </div>
        </div>

        <div className="user-comment">
          <div className="d-flex mb-2 mb-md-4">
            <ProductGlobalRating
              globalRating={review.rating}
              size="20px"
              withRatingsCount={false}
            />
            <p
              className="mb-0 text-gray"
              style={{ marginTop: "3px" }}
            >
              {"\u00A0|\u00A0"}
              {formatDate(review.user_modified_at)}
            </p>
          </div>

          {review.localized_comment && (
            <div className="d-flex flex-column justify-content-between flex-grow-1">
              <p className="mb-0 user-comment-text">
                {t("product:review_comment", { comment: review.localized_comment })}
              </p>
              {locale !== review.lang && (
                <p className="font-size-sm text-gray fst-italic mt-3 mb-0 text-end">
                  {t(`product:translated_from.${review.lang}`)}
                </p>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default withTranslation("product")(ProductReviewCard);
